import { render, staticRenderFns } from "./integralMoney.vue?vue&type=template&id=5c308994&scoped=true"
import script from "./integralMoney.vue?vue&type=script&lang=js"
export * from "./integralMoney.vue?vue&type=script&lang=js"
import style0 from "./integralMoney.vue?vue&type=style&index=0&id=5c308994&prod&lang=less&scoped=true"
import style1 from "./integralMoney.vue?vue&type=style&index=1&id=5c308994&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c308994",
  null
  
)

export default component.exports